import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LoggedOut, fetchUserDetails } from "../../../Pages/Login/loginSlice";
import {
  getWorkOsUserById,
  getEntityAcess,
  addEntityAcess,
} from "../users/invite-modal/InviteModalSlice";
import apiService from "~/services/service";
import API_ROUTES from "../../../api-routes";
import { z } from "zod";

const useMyProfile = () => {
  const dispatch = useDispatch();
  const timezone = useSelector((state) => state.login.timezone || "");
  const [serviceAvailable, setServiceAvailable] = useState([]);
  const [paginationFirst, setPaginationFirst] = useState(0);
  const [paginationRows, setPaginationRows] = useState(10);
  const [isUpateTimezone, setIsUpateTimezone] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [userInfo, setUserInfo] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [entityAccessLoading, setEntityAccessLoading] = useState(false);

  const user_id = useSelector((state) => state.login.id || null);
  const role = useSelector((state) => state.login.role || null);

  const firstName = useSelector((state) => state.login.firstName || "");
  const lastName = useSelector((state) => state.login.lastName || "");
  const workos = useSelector((state) => state.inviteusers.workosuser || {});
  const userdata = useMemo(
    () => ({
      ...workos,
      first_name: workos?.first_name,
      last_name: workos?.last_name,
      other_name: workos?.other_name || "",
      preferred_name: workos?.preferred_name || "",
      timezone,
    }),
    [workos, firstName, lastName, timezone],
  );
  const myentityaccess = useSelector(
    (state) => state.inviteusers.useraccess || [],
  );
  const allTenantData = useSelector(
    (state) => state.inviteusers.allTenantData || [],
  );

  const handleLogout = () => {
    dispatch(LoggedOut());
  };

  useEffect(() => {
    if (user_id) {
      setEntityAccessLoading(true);
      dispatch(getWorkOsUserById(user_id));
      dispatch(getEntityAcess(user_id)).finally(() => {
        setEntityAccessLoading(false);
      });
    }
  }, [user_id]);

  useEffect(() => {
    const uniqueServices = [];
    const serviceIds = new Set();
    myentityaccess.forEach((item) => {
      item.services.forEach((service) => {
        if (!serviceIds.has(service.id)) {
          serviceIds.add(service.id);
          uniqueServices.push(service);
        }
      });
    });
    setServiceAvailable(uniqueServices);
  }, [myentityaccess]);

  const paginationOnchange = (e) => {
    setPaginationFirst(e.first);
    setPaginationRows(e.rows);
  };

  const handleUpdateTimezone = (value) => {
    const payload = {
      id: user_id,
      timezone: value,
    };
    setIsUpateTimezone(true);
    dispatch(addEntityAcess(payload)).then(() => {
      dispatch(fetchUserDetails()).then(() => {
        setIsUpateTimezone(false);
      });
    });
  };

  const handleChange = (name, value) => {
    setUserInfo((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const initialdata = () => {
    let obj = {
      first_name: userdata?.first_name || "",
      other_name: userdata?.other_name ? userdata?.other_name : "",
      last_name: userdata?.last_name || "",
      preferred_name: userdata?.preferred_name || "",
    };
    return obj;
  };
  useEffect(() => {
    const obj = initialdata();
    setUserInfo(userdata);
  }, [userdata]);
  useEffect(() => {
    if (
      (userdata?.first_name === userInfo?.first_name &&
        userdata?.other_name === userInfo?.other_name &&
        userdata?.last_name === userInfo?.last_name &&
        userdata?.preferred_name === userInfo?.preferred_name) ||
      !userInfo?.first_name?.length
    ) {
      setDisabled(true);
    } else {
      setDisabled(false);
    }
  }, [userInfo]);

  const handleUpdateUserInformation = async (e) => {
    try {
      setLoading(true);
      await apiService(API_ROUTES.UPDATE_USER, "PUT", {
        body: {
          first_name: userInfo?.first_name,
          last_name: userInfo?.last_name,
          other_name: userInfo?.other_name,
          preferred_name: userInfo?.preferred_name,
          role,
        },
        replace: { id: user_id },
        schema: z.object({
          id: z.string().uuid(),
          first_name: z.string().optional(),
          last_name: z.string().optional(),
          other_name: z.string().optional(),
          preferred_name: z.string().optional(),
          role: z.enum([
            "CUSTOMER",
            "LSP_USER",
            "GXM_ADMIN",
            "GXM_USER",
            "GXM_MANAGER",
            "LSP_MANAGER",
            "CUSTOMER_MANAGER",
          ]),
        }),
      });
      dispatch(getWorkOsUserById(user_id));
      setIsEditing(false);
      setSuccessMessage("User updated successfully");
    } catch (error) {
      console.log(error);
      setMessage("Something went wrong, please try again later");
    } finally {
      setLoading(false);
    }
  };
  const handleDiscard = () => {
    const data = initialdata();
    setUserInfo(data);
    setIsEditing(false);
  };

  return {
    handleLogout,
    userdata,
    myentityaccess,
    allTenantData,
    serviceAvailable,
    isUpateTimezone,
    paginationFirst,
    paginationRows,
    paginationOnchange,
    handleUpdateTimezone,
    isEditing,
    setIsEditing,
    disabled,
    setDisabled,
    handleChange,
    userInfo,
    message,
    setMessage,
    successMessage,
    setSuccessMessage,
    handleUpdateUserInformation,
    loading,
    entityAccessLoading,
    handleDiscard,
    role,
  };
};

export default useMyProfile;
